import {
  MarketingSection,
  SectionIntro,
  SectionKicker,
  SectionTitle,
} from "@/components/marketing/MarketingSection";

export default function LyricVideoCustomization() {
  return (
    <MarketingSection className="bg-[#F6F7FB]">
      <SectionKicker>Customization</SectionKicker>
      <SectionTitle>Make it your own.</SectionTitle>
      <SectionIntro>
        Customize the text, background, and animation to match your track.
        Preview everything with your music before exporting.
      </SectionIntro>
      <figure className="mt-12 overflow-hidden rounded-[24px] border border-[#DFE3EF] bg-white p-3 max-[680px]:mt-[34px] max-[680px]:rounded-[18px] max-[680px]:p-[7px]">
        <img
          src="/marketing/lyric-video/lyric-video-editor.webp"
          alt="Lutely lyric video editor showing text, background, and animation controls"
          width={2048}
          height={969}
          loading="lazy"
          className="h-auto w-full rounded-[14px]"
        />
        <figcaption className="px-[6px] pb-[2px] pt-[10px] text-center font-open-sans text-[14px] leading-[1.55] text-[#6F778C]">
          Actual Lutely lyric video editor.
        </figcaption>
      </figure>
    </MarketingSection>
  );
}
